module.exports = __webpack_public_path__ + "static/media/Icone3-formation.98e9a5d1.svg";